var VideoUploadComponent = new JS.Class(EditorComponent, {
  initialize: function(titleSelector, urlSelector, uploadVideoIdSelector) {
    this.titleField = $(titleSelector);
    this.urlField = $(urlSelector);
    this.uploadVideoId = $(uploadVideoIdSelector);
  },

  getSaveData: function() {
    var response = {
      Video: {
        title: this.titleField.val(),
        url: this.urlField.val(),
      },
    };

    if (this.uploadVideoId && this.uploadVideoId.length) {
      response['Video']['uploadVideoId'] = this.uploadVideoId.val();
      response['Video']['type'] = this.uploadVideoId.is(':visible')
        ? 'upload'
        : 'url';
    }
    return response;
  },
});
